import styled from 'styled-components';

import { spaceXXL } from '@xing-com/tokens';

export const UploadHeadline = styled.div`
  margin-bottom: ${spaceXXL};
`;
